module.exports = __webpack_public_path__ + "img/Headset.91e26d9d.svg";